import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { ArrowForward as ArrowForwardIcon } from '@material-ui/icons';
import { ROUTE_CONSTANTS } from 'constants/route';
import { formatCurrency } from 'helpers/number';
import CountyFromState from 'components/CountyFromState';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    fontFamily: 'Roboto Slab',
  },
  cardHeader: {
    display: 'inline-flex',
    margin: '0 auto 1rem auto',
    textAlign: 'left',
  },
  cardSubtitle: {
    fontSize: '0.75rem',
    lineHeight: '0.75rem',
  },
  countyAvatar: { flexBasis: '60px' },
  countyName: {
    flex: 1,
    fontSize: '1.4rem',
    color: '#606060',
    padding: '0.625rem 0.75rem 0 0',
    lineHeight: '1.5rem',
  },
  cardBody: {
    textAlign: 'left',
    padding: '0 0.75rem',
    color: '#606060',
    fontSize: '0.875rem',
  },
  dataPoint: {
    display: 'flex',
    marginBottom: '0.5rem',
  },
  pointName: {
    flex: 1,
    fontWeight: 'bold',
  },
  pointValue: {
    flex: 1,
    textAlign: 'right',
  },
  cardFooter: {
    paddingTop: '1rem',
    paddingBottom: '1rem',
  },
  cta: {
    backgroundColor: '#ff7c09',
    color: '#fff',
    fontFamily: 'Roboto Slab',
    textTransform: 'none',
    fontWeight: 'bold',
  },
}));

const CountyDetails = ({
  county: {
    name = '',
    details: {
      commercialPremium = 0,
      countyId,
      quarterYear,
      residentialPremium = 0,
      topCoverageCode = '',
      topInsurerName = '',
      totalPremium = 0,
    } = {},
  },
  mapId = 'CountyFromState1',
}) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const goToCountyProfilePage = useCallback(() => {
    let currentQuarterYear = quarterYear.split(' ');
    let quarter = currentQuarterYear.length > 0 ? currentQuarterYear[0].replace('Q', '') : '';
    let year = currentQuarterYear.length > 1 ? currentQuarterYear[1] : '';
    navigate(`${ROUTE_CONSTANTS.COUNTY}?counties=${countyId}&quarter=${quarter}&year=${year}`);
    ///${name.toLocaleLowerCase()}
  }, [navigate, quarterYear, countyId]);
  //name

  return (
    <div className={classes.root} data-testid="country-details-root">
      <div className={classes.cardHeader}>
        <div className={classes.countyAvatar}>
          <CountyFromState countyName={name} size={60} id={mapId} />
        </div>
        <div className={classes.countyName}>
          {name} County
          <div className={classes.cardSubtitle}>{quarterYear}</div>
        </div>
      </div>
      <div className={classes.cardBody}>
        <div className={classes.dataPoint}>
          <div className={classes.pointName}>Total Premium</div>
          <div className={classes.pointValue}>{formatCurrency(totalPremium)}</div>
        </div>
        <div className={classes.dataPoint}>
          <div className={classes.pointName}>Commercial Premium</div>
          <div className={classes.pointValue}>{formatCurrency(commercialPremium)}</div>
        </div>
        <div className={classes.dataPoint}>
          <div className={classes.pointName}>Residential Premium</div>
          <div className={classes.pointValue}>{formatCurrency(residentialPremium)}</div>
        </div>
        <div className={classes.dataPoint}>
          <div className={classes.pointName}>Top Coverage Code</div>
          <div className={classes.pointValue}>{topCoverageCode}</div>
        </div>
        <div className={classes.dataPoint}>
          <div className={classes.pointName}>Top Insurer</div>
          <div className={classes.pointValue}>{topInsurerName}</div>
        </div>
      </div>
      <div className={classes.cardFooter}>
        <Button
          variant="contained"
          className={classes.cta}
          disableElevation
          endIcon={<ArrowForwardIcon />}
          onClick={goToCountyProfilePage}
        >
          Learn more about {name} County
        </Button>
      </div>
    </div>
  );
};

export default CountyDetails;
